import { utcToZonedTime } from 'date-fns-tz';

import { convertToUtc } from './convert-to-utc';

export function convertToClientTimezone(date: Date, timezone?: string) {
  const clientTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const utcDate = convertToUtc(date, timezone);

  return utcToZonedTime(utcDate, clientTimezone);
}
